// extracted by mini-css-extract-plugin
export var label = "GoesWellWith-module--label--wA4Hp";